import { useDeviationSubscription } from '../../../../../hooks/useDeviationSubscription';
import { useDeviationAlertsQuery } from './useDeviationAlertsQuery';
import { useDeviationAlertsSummaryQuery } from './useDeviationAlertsSummaryQuery';
export const useDeviationAlertsSubscription = (widgetType) => {
    const { refetch, data, isLoading } = useDeviationAlertsQuery(widgetType);
    const { refetch: refetchSummary } = useDeviationAlertsSummaryQuery(widgetType);
    useDeviationSubscription(widgetType, refetch);
    useDeviationSubscription(widgetType, refetchSummary);
    return { data, isLoading, refetch };
};
//# sourceMappingURL=useDeviationAlertsSubscription.js.map